const OPERATIONS = {
  /**
   * Получение значения свойства
   * ['get', '<fieldName>']
   * @param {*} param0
   * @param {*} properties
   * @returns
   */
  get: ([fieldName], properties) => {
    return properties[fieldName]
  },

  ['>']: ([expression1, expression2], properties) => {
    return evaluateExpression(expression1, properties) > evaluateExpression(expression2, properties)
  },

  ['>=']: ([expression1, expression2], properties) => {
    return evaluateExpression(expression1, properties) >= evaluateExpression(expression2, properties)
  },

  ['<']: ([expression1, expression2], properties) => {
    return evaluateExpression(expression1, properties) < evaluateExpression(expression2, properties)
  },

  ['<=']: ([expression1, expression2], properties) => {
    return evaluateExpression(expression1, properties) <= evaluateExpression(expression2, properties)
  },

  ['==']: ([expression1, expression2], properties) => {
    return evaluateExpression(expression1, properties) == evaluateExpression(expression2, properties)
  },

  ['*']: (expressions, properties) => {
    return expressions.reduce((result, subExpression) => {
      return result * evaluateExpression(subExpression, properties)
    }, 1)
  },

  literal: ([expressions]) => {
    return expressions
  },

  all: (expressions, properties) => {
    return expressions.reduce((result, subExpression) => {
      return result && evaluateExpression(subExpression, properties)
    }, true)
  },

  any: (expressions, properties) => {
    return expressions.reduce((result, subExpression) => {
      return result || evaluateExpression(subExpression, properties)
    }, true)
  },

  /**
   * ['case', <Значение или выражение true или false>, <Значение которек вернет case>, таких пар может быть несколько]
   * В конце значение, которое надо вернуть если ничего не выполнилось
   * @param {*} expression
   * @param {*} properties
   * @returns
   */
  case: (expression, properties) => {
    if (expression.length < 3) {
      throw new Error(`Operation 'case' required > 3 operands`)
    }

    for (let index = 0; index < expression.length - 1; index = index + 2) {
      const conditionValue = evaluateExpression(expression[index], properties)
      if (conditionValue) {
        return evaluateExpression(expression[index + 1], properties)
      }
    }

    return evaluateExpression(expression[expression.length - 1], properties)
  },

  /**
   * Возвращает первное истиное значение или первое значение
   * @param {*} expression
   * @param {*} properties
   */
  coalesce: (expression, properties) => {
    for (const expressionItem of expression) {
      const expressionResult = evaluateExpression(expressionItem, properties)
      if (expressionResult) {
        return expressionResult
      }
    }

    return evaluateExpression(expression[0], properties)
  }
}

export function evaluateExpression(expression, properties = {}) {
  if (!Array.isArray(expression)) {
    if (typeof expression === 'object') {
      return Object.entries(expression).reduce((result, [fieldName, fieldValue]) => {
        result[fieldName] = evaluateExpression(fieldValue, properties)
        return result
      }, {})
    }

    return expression
  }

  const [operationKey, ...operationParams] = expression
  const operation = OPERATIONS[operationKey]

  if (!operation) {
    //TODO: может лучше просто вернуть expression как есть?
    throw new Error(`Unknown operation: ${operationKey}`)
  }

  return operation(operationParams, properties)
}



// WEBPACK FOOTER //
// ./src/helpers/evaluate-expression.js